module.exports = __webpack_public_path__ + "media/images/athletes/416-d66f5b6826831da6c86a00946f7acaec.png";